import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser, PopupModal } from "../Components";
import Masters from "../Components/masters.json";
import axiosConfig from "../Service/axiosConfig";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";

const StoreManagement = () => {
    const MastersModal = Masters.StoreManager
    const [Data, SetData] = useState([])
    const [popupType, setpopupType] = useState("")
    const [Error, SetError] = useState("")
    const [message, setMessage] = useState("")
    const user_data = JSON.parse(localStorage.getItem('user_data'))
    const Store_Id = JSON.parse(localStorage.getItem('Store'))?.id
    let { storeId } = useParams()
    let id = user_data.role === 'Admin' ? storeId : Store_Id;
    const formSubmit = (Data, setFieldErrors) => {
        console.log(Data)
        const coordsArray =
          Data.polygon && Data.polygon.length >= 3
            ? Data.polygon
            : Data.polygon_coordinates && Data.polygon_coordinates.length >= 3
            ? Data.polygon_coordinates
            : [];

        if (coordsArray.length < 3) {
          SetError("Please draw a delivery polygon boundary on the map (minimum 3 points required).");
          setpopupType("error");
          return;
        }

        const data_to_post = {
          ...Data,
          logo_image: typeof Data.logo_image === "object" ? Data.logo_image?.id : Data.logo_image,
          banner_image: typeof Data.banner_image === "object" ? Data.banner_image?.id : Data.banner_image,
          boundary_type: "polygon",

          polygon_coordinates: coordsArray.map((point) => {
            if (Array.isArray(point)) {
              return {
                lat: Number(point[0]),
                lng: Number(point[1]),
              };
            }
            return {
              lat: Number(point?.lat !== undefined ? point.lat : point?.[0] || 0),
              lng: Number(point?.lng !== undefined ? point.lng : point?.[1] || 0),
            };
          }),
          spike_percentage:
            parseFloat(Data.spike_percentage) > 0
              ? parseFloat(Data.spike_percentage)
              : 0.0,
          slot_duration:
            Data.slot_duration !== undefined && Data.slot_duration !== ""
              ? Number(Data.slot_duration)
              : 0,
        };

        if (Data.express_delivery !== undefined) {
          data_to_post.express_delivery =
            Data.express_delivery === true || Data.express_delivery === "true" ? "true" : "false";
        }
        if (Data.schedule_delivery !== undefined) {
          data_to_post.schedule_delivery =
            Data.schedule_delivery === true || Data.schedule_delivery === "true" ? "true" : "false";
        }
        if (Data.latitude !== undefined && Data.latitude !== "") {
          data_to_post.latitude = Number(Data.latitude);
        }
        if (Data.longitude !== undefined && Data.longitude !== "") {
          data_to_post.longitude = Number(Data.longitude);
        }

        const hasFiles = Object.values(data_to_post).some(
          (val) => val instanceof File || val instanceof Blob
        );
        if (hasFiles) {
          axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
        } else {
          axiosConfig.defaults.headers["Content-Type"] = "application/json";
        }

        axiosConfig.put(`/stores/stores/${id}/`, data_to_post).then(res => {
            console.log(res)
            setMessage(res.data?.message || "Store updated successfully")
            setpopupType("success")
        }).catch(error => {
            console.log(error)
            const ErrorData = []
            ErrorData.push({
                code: error.response?.data?.code || ["null"],
                name: error.response?.data?.name || ["null"],
            })
            console.log(ErrorData[0])
            if (ErrorData[0].code[0] === "priority with this code already exists.") {
                SetError(" code already exists.")
            }
            if (ErrorData[0].name[0] === "priority with this name already exists.") {
                SetError("Tittle already Exists")
            }
            if (error.response?.data?.detail) {
                SetError(error.response.data.detail)
            }
            setpopupType("error")
        })
    }
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/stores/stores/${id}/`)
            console.log(responce)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }

    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <div className="dashboard-header">
                <h5 className="dashboard-subtitle">Edit store {id}</h5>
                <NavLink to="/dashboard/masters/inventory" ><button className="btn btn-white">Manage Products</button></NavLink>
                <NavLink to="/dashboard/orders" ><button className="btn btn-white">Manage Orders</button></NavLink>
            </div>
            <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error} />
            {popupType != "" &&
                <PopupModal popupType={popupType} Message={message} setMessage={setMessage} error={Error} setpopupType={setpopupType} />
            }
        </>
    )
}

export { StoreManagement }